import type { TFunction } from 'i18next';

import { Pause, Play, type LucideIcon } from 'lucide-react';

export const getVideoPauseToggle = (
  isVideoPaused: boolean,
  t: TFunction<'cameraControl'>
): { label: string; Icon: LucideIcon } => ({
  label: isVideoPaused ? t('resumeVideo') : t('pauseVideo'),
  Icon: isVideoPaused ? Play : Pause,
});
